// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-landing-page -> american-landmark-landing-page -> clear-springs-lp
// Generated: 2026-10-09T16:39:57.179Z
// Counts: 0 design, 3 content, 5 slot group, 2 collection binding, 3 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "header.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_ppc_tracking_phone_number"
  },
  "hero.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "multihub-lead-capture.lead_source": {
    "overrideType": "VALUE",
    "customValue": "LANDING_PAGE",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "header.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "query_params": {
        "type": "VALUE",
        "customValue": "?utm_knock=gpaid"
      }
    }
  },
  "hero.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "query_params": {
        "type": "VALUE",
        "customValue": "?utm_knock=gpaid"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_company_mono_white_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_company_mono_white_logo_media.alt_text"
      }
    }
  },
  "thankyouhero.visit_website_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "query_params": {
        "type": "VALUE",
        "customValue": "?utm_knock=gpaid"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "neighborhoodmap.pois": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    }
  ],
  "home": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync",
      "position": 6
    }
  ]
};

export const styleOverrides = {};
